import { useActiveSite } from 'es/app/store/hooks';
import { createSiteRouteMap } from 'es/app/views/site/RouteMap';
import { useMemo } from 'react';

export const useSiteRouteMap = () => {
    const activeSite = useActiveSite();
    return useMemo(() => createSiteRouteMap(activeSite?.companyAlias, activeSite?.facilityAlias), [activeSite]);
};
